import { createReducer, on } from '@ngrx/store';
import * as AccountActions from './account.actions';

export interface AccountState {
  isPasswordValidating: boolean;
  passwordValidationMessage: string | null;
  passwordValidationError: string | null;
  deleteMessage: string | null;
  deleteError: string | null;
}

export const initialState: AccountState = {
  isPasswordValidating: false,
  passwordValidationMessage: null,
  passwordValidationError: null,
  deleteMessage: null,
  deleteError: null,
};

export const accountReducer = createReducer(
  initialState,
  on(AccountActions.validatePassword, (state ) => ({ ...state, isPasswordValidating: true, passwordValidationMessage: null, passwordValidationError: null })),
  on(AccountActions.validatePasswordSuccess, (state, { message }) => ({ ...state, isPasswordValidating: false, passwordValidationMessage: message, passwordValidationError: null })),
  on(AccountActions.validatePasswordFailure, (state, { error }) => ({ ...state, isPasswordValidating: false, isPasswordValid: false, passwordValidationError: error })),
  on(AccountActions.deleteAccount, state => ({ ...state, deleteMessage: null, deleteError: null })),
  on(AccountActions.deleteAccountSuccess, (state, { message }) => ({ ...state, deleteMessage: message, deleteError: null })),
  on(AccountActions.deleteAccountFailure, (state, { error }) => ({ ...state, deleteMessage: null, deleteError: error }))
);
